import styled from 'styled-components';
import { MdFaceUnlock, MdArrowForward } from 'react-icons/md';

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding: 14px 8px 14px 16px;
  background-color: ${props => props.primaryColor};
  color: ${props => props.textColor};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;

export const ButtonIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonIcon = styled(MdFaceUnlock)``;

export const ButtonTexts = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  text-align: left;
`;

export const ButtonText = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
`;

export const ButtonSubtitle = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
`;

export const ArrowIcon = styled(MdArrowForward)`
  margin-left: auto;
`;
